import React from "react";
import { useTranslation } from "react-i18next";
import {
  Heading,
  StyledArchive,
  YearItems,
  YearItem,
  YearItemHeading,
  QuarterItems,
  QuarterItem,
  Highlight,
  QuarterLink,
} from "./Archive.style";
import PropTypes from "prop-types";

/**
 * Archive Page - Show a list of previous reports.
 */
const Archive = ({ quarters, onQuarterChange, activeQuarter, ...rest }) => {
  const { t } = useTranslation();

  const handleChangeQuarter = (e) => {
    e.preventDefault();
    const data = e.currentTarget.dataset;
    onQuarterChange(parseInt(data.year), parseInt(data.quarter));
  };

  return (
    <StyledArchive>
      <Heading>{t("archive.heading")}</Heading>
      <YearItems>
        {quarters.map(([year, reports]) => (
          <YearItem key={year} data-testid={`archive_year${year}`}>
            <YearItemHeading
              dangerouslySetInnerHTML={{
                __html: t("archive.reports.heading", { year }),
              }}
            />
            <QuarterItems>
              {reports.map((report) => (
                <QuarterItem key={year + "_" + report.id}>
                  {!report.link ? (
                    <QuarterLink
                      isActive={
                        activeQuarter[0] === parseInt(year) &&
                        activeQuarter[1] === parseInt(report.id)
                      }
                      href="#"
                      data-year={year}
                      data-quarter={report.id}
                      onClick={handleChangeQuarter}
                      data-testid={`archive_year${year}_quarter${report.id}_link`}
                    >
                      {t("archive.reports.quarterHeading", {
                        quarter: parseInt(report.id),
                      })}
                    </QuarterLink>
                  ) : (
                    <QuarterLink
                      isActive={false}
                      href={report.link}
                      data-year={year}
                      data-quarter={report.id}
                      data-testid={`archive_year${year}_quarter${report.id}_link`}
                      download="download"
                      target="_blank"
                    >
                      {t("archive.reports.quarterHeading", {
                        quarter: parseInt(report.id),
                      })}
                    </QuarterLink>
                  )}
                </QuarterItem>
              ))}
            </QuarterItems>
          </YearItem>
        ))}
      </YearItems>
    </StyledArchive>
  );
};

Archive.propTypes = {
  quarters: PropTypes.array.isRequired,
  activeQuarter: PropTypes.array,
  onQuarterChange: PropTypes.func.isRequired,
};
export default Archive;
